import React, { useCallback, useState, useEffect } from "react";
import { TextInput, PrimaryButton, AleartModalButton } from "../../components/UIkit";
import { useDispatch, useSelector } from "react-redux";
import { getUserId } from "../../reducks/users/selectors";
import { ImageAreaSum } from "../../components/booths";
import { deleteOpus, fechSelectedOpus, saveOpus } from "../../reducks/opuses/operations";
import { OrganizerHeader } from "../../components/header";
import { getSelectedOpus } from "../../reducks/opuses/selectors";
import { fetchMyOpuses } from "../../reducks/opuses/operations";
import { push } from "connected-react-router";

const OpusEdit = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const uid = getUserId(selector);
  const opus = getSelectedOpus(selector);
  const isBoothEditing = true;
  const isOpusEditing = false;

  const [name, setName] = useState(""),
    [id, setId] = useState(""),
    [description, setDescription] = useState(""),
    [size, setSize] = useState(""),
    [images, setImages] = useState([]),
    [price, setPrice] = useState("");

  const inputName = useCallback(
    (event) => {
      setName(event.target.value);
    },
    [setName]
  );

  const inputDescription = useCallback(
    (event) => {
      setDescription(event.target.value);
    },
    [setDescription]
  );

  const inputSize = useCallback(
    (event) => {
      setSize(event.target.value);
    },
    [setSize]
  );

  const inputPrice = useCallback(
    (event) => {
      setPrice(event.target.value);
    },
    [setPrice]
  );

  const validateRequiredInput = (...args) => {
    let isBlank = false;
    for (let i = 0; i < args.length; i = (i + 1) | 0) {
      if (args[i] === "") {
        isBlank = true;
      }
    }
    return isBlank;
  };

  const validateRequiredOpus = (images) => {
    let isValidImage = false;
    if (images.length > 0) {
      isValidImage = true;
    }
    return isValidImage;
  };

  const submitOpus = () => {
    const isBlank = validateRequiredInput(name, description, size, price);
    const isValidImage = validateRequiredOpus(images);
    if (isBlank) {
      alert("必須入力欄が空白です");
      return false;
    } else if (!isValidImage) {
      alert("作品画像は1枚以上が必須となります");
      return false;
    } else {
      dispatch(saveOpus(id, uid, images, name, description, size, price));
    }
  };

  const fechOpusData = () => {
    setName(opus.name);
    setImages(opus.images);
    setDescription(opus.description);
    setSize(opus.size);
    setPrice(opus.price);
  };

  useEffect(() => {
    let getid = window.location.pathname.split("/opus/edit/")[1];
    setId(getid);
    dispatch(fetchMyOpuses(uid));
    if (getid !== "") {
      dispatch(fechSelectedOpus(getid));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (id !== "") {
      fechOpusData();
    }
    // eslint-disable-next-line
  }, [opus]);

  return (
    <section>
      <div className="common-container">
        <div className="common-container__header--inner center-box">
          <OrganizerHeader isBoothEditing={isBoothEditing} isOpusEditing={isOpusEditing} />
          <div className="mypage-container">
            <h2 className="form-text__headline--l center">作品の登録</h2>
            <div className="spacer-box--s" />
            <div>
              <div className="spacer-box--s" />
              <ImageAreaSum images={images} setImages={setImages} uid={uid} />
              <div className="spacer-box--m" />
              <TextInput
                fullWidth={true}
                label={"タイトル"}
                multiline={false}
                required={true}
                onChange={inputName}
                rows={1}
                value={name ?? ""}
                type={"text"}
              />
              <div className="spacer-box--s" />
              <TextInput
                fullWidth={true}
                label={"作品説明"}
                multiline={true}
                required={true}
                onChange={inputDescription}
                rows={5}
                value={description ?? ""}
                type={"text"}
              />
              <div className="spacer-box--s" />
              <TextInput
                fullWidth={true}
                label={"サイズ"}
                multiline={false}
                required={true}
                onChange={inputSize}
                rows={1}
                value={size ?? ""}
                type={"text"}
              />
              <div className="spacer-box--s" />
              <TextInput
                fullWidth={true}
                label={"価格"}
                multiline={false}
                required={true}
                onChange={inputPrice}
                rows={1}
                value={price ?? ""}
                type={"number"}
              />
              <div className="spacer-box--l" />
              <div className="center">
                <PrimaryButton label={"作品を保存"} onClick={() => submitOpus()} />
              </div>
              <div className="center">
                <div className="spacer-box--s" />
                <AleartModalButton
                  title="保存されいない内容は消去されます"
                  text="よろしいですか？"
                  onClick={() => dispatch(push(`/organizer/${uid}`))}
                  label="TOPへ戻る"
                  className="top-back-btn"
                />
                <div className="spacer-box--l" />
                <AleartModalButton
                  title="作品を削除します"
                  text="よろしいですか？"
                  onClick={() => dispatch(deleteOpus(id, uid))}
                  label="作品を削除"
                  className="delete-btn"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpusEdit;
